import Helmet from './components/Helmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedStories from './components/FeaturedStories';
import CategoriesSection from './components/CategoriesSection';
import HotArticles from './components/HotArticles';
import QuotesSection from './components/QuotesSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Helmet />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedStories />
        <CategoriesSection />
        <HotArticles />
        <QuotesSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}